var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"boton-new",class:{ [_vm.getClassSize()]: true, [_vm.getClassType()]: true, 'w-full': _vm.fullWidth  },attrs:{"disabled":_vm.disabled},on:{"click":_vm.handleClick}},[_vm._v("\n  "+_vm._s(_vm.title)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }